import { render } from "./walletShow.vue?vue&type=template&id=0c4bc2fc&scoped=true"
import script from "./walletShow.vue?vue&type=script&lang=js"
export * from "./walletShow.vue?vue&type=script&lang=js"

import "./walletShow.vue?vue&type=style&index=0&id=0c4bc2fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4bc2fc"]])

export default __exports__